/* eslint-disable no-unused-vars */
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

const INSIGHT_API_URL = 'https://creeksidewines.insight-experience.insightplatform.ai/api';
const NO_IMG_URL = 'https://cdn.shopify.com/s/files/1/0846/2355/6912/files/no-image.png?v=1708464056';
